export default "__VITE_ASSET__DtWU1OAs__"